module.exports = __webpack_public_path__ + "static/img/fzg.caac503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fzg.png
// module id = GHru
// module chunks = 1